import { callKakaostyleMktFunction } from '../../callKakaostyleMktFunction';

export const logBraze = (eventName: string, parameters?: object) => {
  callKakaostyleMktFunction('logBraze', eventName)(parameters);
};
